import { CreateEventFormAnswersForm } from "@ac-expo/api";
import { EventFormQuestion } from "@ac-expo/api-types";
import { formatSelectedCount } from "@ac-expo/utils";
import { CaretDownIcon } from "@phosphor-icons/react";
import { Control, useController } from "react-hook-form";
import { BusinessSectorMultiSelect } from "@ac-expo/ui-components";

type EventFormBusinessSectorSelectProps = {
  question: EventFormQuestion;
  control: Control<CreateEventFormAnswersForm>;
  index: number;
  eventId: string;
};

export const EventFormBusinessSectorSelect = ({
  question,
  control,
  index,
  eventId,
}: EventFormBusinessSectorSelectProps) => {
  const { field, fieldState } = useController({
    control,
    name: `answers.${index}.answerList`,
  });

  const selectedIds = (field.value as string[]) || [];

  const handleConfirm = (ids: string[]) => {
    field.onChange(ids);
  };

  return (
    <div className="space-y-2">
      <p className="text-sm text-gray-600">
        {question.theme} : {question.question}
      </p>

      <BusinessSectorMultiSelect
        selectedIds={selectedIds}
        onConfirm={handleConfirm}
        eventId={eventId}
      >
        <button
          type="button"
          className="flex w-full items-center justify-between rounded-lg border border-gray-200 bg-white px-4 py-3 text-left hover:bg-gray-50"
        >
          <span className="flex-1 truncate text-sm text-gray-700">
            {formatSelectedCount(selectedIds.length, "Sélectionner vos centres d'intérêt")}
          </span>
          <CaretDownIcon size={20} className="text-gray-400" />
        </button>
      </BusinessSectorMultiSelect>

      {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
    </div>
  );
};
